import { APP_ROOT_ELEMENT_ID } from '../../../constants/env';

export const DEFAULT_SCROLL_ELEMENT =
  document.getElementById(APP_ROOT_ELEMENT_ID) || window;
